import React from "react";
import classes from "./itemCheckbox.module.scss";
import CorrectIcon from "assets/icons/correct.svg";
import { FormattedMessage } from "react-intl";
import FormattedHTMLMessage from "../FormattedHTMLMessage";

import Lottie from "react-lottie";

import CameraIcon from "../../../pages/Camera/camera.png"
import CameraIconGreen from "../../../pages/Camera/camera_green.png"

import CrossIcon from "./close.svg"

//animations
import CheckAnimation from "assets/animations/Check-small-v3.json";

const ItemCheckBox = (props) => {

  return (
    <div className={classes.ItemCheckboxWrapper}>
      <div onClick={props.onClick} className={props?.type == 'custom' ? !props.checked ? classes.ItemCardCustomUnChecked : classes.ItemCardCustom : classes.ItemCard}>
        {props?.type =="document" && (
          <div>
          <div className={classes.ItemIcon}>
            <img src={props.checked? CameraIconGreen : CameraIcon} />
          </div>
          {props?.checked && (
            <div className={classes.ItemDocumentUploadedText}>
                Document Uploaded
            </div>
          )}
          </div>
        )}
        <div className={(!props.checked && props.type == 'custom') ? classes.CheckboxCustomUnChecked : classes.Checkbox} onClick={props.onClick}>
          {(!props.checked && props.type == 'custom') && (
              <img src={CrossIcon} />
          )}

          {props.checked && (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: CheckAnimation,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                  progressiveLoad: true,
                },
              }}
              width={"100%"}
              isClickToPauseDisabled={true}
              isPaused={false}
              title={"animation"}
              ariaLabel={"animation"}
            />
          )}
        </div>
        <span className={classes.ItemText}>
          {(props.type == 'custom') && (
              <><span className={classes.ItemChargeUP}>CHARGE UP</span><br /></>
          )}
          <FormattedHTMLMessage id={props?.formatID} value={props?.title} defaultValue={props?.title} items={props?.textItems} />
        </span>
      </div>
    </div>
  );
};

export default ItemCheckBox;
